<template>
    <div class="introduction">

        <div class="protrack">
            ProTrack
        </div>

        <div class="cptac-description">
            <p>This interactive data portal supports query, visualization, and downloads of multi-omics data from comprehensive proteogenomic studies by the <a href="https://proteomics.cancer.gov/programs/cptac">Clinical Proteomic Tumor Analysis Consortium (CPTAC).</a></p>
            <p>NCI-supported CPTAC is a comprehensive and coordinated effort to accelerate the understanding of the molecular basis of cancer through the application of large-scale proteome (proteins) and genome (DNA and RNA) analysis technologies to different cancer types. Through collaboration with leaders in the field, CPTAC’s mission is to accelerate precision oncology through state-of-the-art proteogenomics and create open-source community resources.</p>
            <p>For more information, please see the ProTrack paper:
            <br><a href="https://pubmed.ncbi.nlm.nih.gov/32510176/">ProTrack: An Interactive Multi-Omics Data Browser for Proteogenomic Studies.<br> Calinawan et al. Proteomics. Nov 2020. DOI: 10.1002/pmic.201900359</a></p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "introduction"
    }
</script>

<style scoped>
    .introduction {
        background: #91818a;
        padding: 2em;
        color: white;
        display: flex;
    }

    .protrack {
        font-weight: bold;
        font-size: 2.5em;
        margin-right: 1em;
        margin-top: 10px;
        min-width: 20%;
        max-width: 20%;
        text-align: right;
    }

    .cptac-description {
        font-size: 1em;
        min-width: 70%;
        max-width: 70%;
    }

    .cptac-description a {
        color: white;
        font-weight: bold;
        text-decoration: underline;
    }
</style>